export default "__VITE_ASSET__ac936bee__"